import { APPLE_CLIENT_ID, APPLE_SITE_URL } from '../config/Master';

export const appleAuth = async (callback: any) => {
  window.AppleID.auth.init({
    clientId: APPLE_CLIENT_ID,
    scope: 'name email',
    redirectURI: APPLE_SITE_URL,
    usePopup: true,
  });

  try {
    const data = await window.AppleID.auth.signIn();

    callback(data);
  } catch (err) {
    console.log(err);
  }
};
